import { takeLatest, put, select } from 'redux-saga/effects';
import { LOGGING_START, LOGGING_POST_INFO, LOGGING_POST_INFO_SUCCESS } from '../constants/log';
import { logging, logNative } from '../utils/utils';

function* fetchLogging(info) {
  try {
    const machineInfo = yield select(state => state.native.machineInfo);
    const commandLine = yield select(state => state.native.commandLine);
    yield logging(info.logInfo, machineInfo, commandLine);
  } catch (error) {
    logNative(`logging error${error}`, error);
  }
}

function* fetchPostLogInfo(info) {
  try {
    let logInfo = yield select(state => state.log.logInfo);
    logInfo = Object.assign(logInfo, info.logInfo);
    yield put({
      type: LOGGING_POST_INFO_SUCCESS,
      logInfo,
    });
  } catch (error) {
    logNative(`logging error${error}`, error);
  }
}

export function* watchLogging() {
  yield takeLatest(LOGGING_START, fetchLogging);
}
export function* watchPostLogInfo() {
  yield takeLatest(LOGGING_POST_INFO, fetchPostLogInfo);
}
